import { Minus, Plus } from "../icons";
import { cn } from "../../lib/utils";

/**
 * Quantity − n + (F123): one pill, Persian digits, used by the cart, the
 * product page and quick-buy. `min` 0 lets the minus remove the line (the
 * cart labels it «حذف» at 1).
 */
export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max = 100,
  disabled,
  minusLabel = "کاهش تعداد",
  className,
}: {
  value: number;
  onChange: (n: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  minusLabel?: string;
  className?: string;
}) {
  const btn = "flex size-8 items-center justify-center rounded-full transition-colors hover:bg-background disabled:opacity-40 disabled:hover:bg-transparent";
  return (
    <div className={cn("bg-surface inline-flex shrink-0 items-center gap-1 rounded-full p-0.5", className)} role="group" aria-label="تعداد">
      <button type="button" className={btn} onClick={() => onChange(value + 1)} disabled={disabled || value >= max} aria-label="افزایش تعداد">
        <Plus size={14} />
      </button>
      <span className="min-w-6 text-center text-sm font-semibold tabular-nums" aria-live="polite">
        {value.toLocaleString("fa-IR")}
      </span>
      <button type="button" className={btn} onClick={() => onChange(value - 1)} disabled={disabled || value <= min} aria-label={minusLabel}>
        <Minus size={14} />
      </button>
    </div>
  );
}
